/**
 * Created by aleco on 9/26/2017.
 */

import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, inject } from '@angular/core';
import { ServiceComponent } from "../service.component";
import { Service } from "../../../../entities/service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ServiceService } from "../../../../services/service.service";
import { FileItem, FileUploader, ParsedResponseHeaders } from "ng2-file-upload";
import { Router } from "@angular/router";
import { SharedService } from 'src/app/services/sharedService';
import { TasService } from 'src/app/services/tas.service';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/entities/user';
import {FetchType} from "./csv-upload.component";
import {ExternalApiGatewayService} from "../../../../services/external-api-gateway.service";
import {ToastrService} from "ngx-toastr";
import {finalize} from "rxjs/operators";
import { portalSlug } from '../../../../utils/portal-slug';
import { ControlContainer } from '@angular/forms';

@Component({
    selector: '<ntr-service-csv>',
    templateUrl: './service-csv.component.html',
    standalone: false,
    // Bridges this component's own ngModel fields (canCreateCompanies, the
    // publish toggles, the portal code, etc.) into the ancestor <form
    // #serviceForm="ngForm"> in service-edit.component.html. Without this,
    // NgModel's own DI lookup for its ControlContainer is host-scoped to this
    // component and never sees the parent's <form>, so none of these fields
    // -- including the new `required` portal code (I2) -- would ever affect
    // serviceForm.form.valid, and the Save button would stay enabled.
    viewProviders: [
      {
        provide: ControlContainer,
        useFactory: () => inject(ControlContainer, { skipSelf: true, optional: true }),
      },
    ],
})
export class ServiceCsvComponent implements ServiceComponent, OnInit, OnChanges {
  ngOnInit(): void {
     this.userService.getCurrentUser().subscribe(user => {
         this.user = user;
     });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['service']) {
      this.resolveExpandedFormat();
    }
  }
  @ViewChild('fileUpload', { static: false }) selectedFile: any;
  
  @Input() currencies: any[];
  @Input() service: Service;
  modalRef: BsModalRef;
  modalRefErrorMessage: BsModalRef;
  selectedFileFormat = {};
  errorMessage: string;
  @ViewChild('informationTemplate', { static: false })
  private informationTemplate: TemplateRef<any>;
  public uploader: FileUploader;
  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;
  fileFormatId: any;
  user: User;
  activeId: any;
  /** id of the single file format currently expanded in the accordion, or null when none is. */
  expandedFormatId: any = null;
  
  constructor(private modalService: BsModalService,
              private userService: UserService,
              private serviceService: ServiceService,
              private router: Router,
              public tasService: TasService,
              public sharedService: SharedService,
              private externalApiService: ExternalApiGatewayService,
              private alertService: ToastrService) {
    this.uploader = new FileUploader({url: sharedService.apiUrl('api/services')+'csv_file_upload',
    authToken: "Bearer " + localStorage.getItem('access_token'),
  });
    this.uploader.onBuildItemForm = (item, form) => {
      form.append("serviceId", this.service.id);
      form.append("fileFormatId", this.fileFormatId);
      form.append("serviceName", this.service.name);
      form.append("fileFormatName", this.service.fileFormats.find(fileFormat => fileFormat['id'] === this.fileFormatId)['name']);
    };
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let data = JSON.parse(response); //success server response
    this.router.navigateByUrl('/batch-process/'+data);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
  }

  openModalMessage(template: TemplateRef<any>) {
    this.modalRefErrorMessage = this.modalService.show(template, {class: 'modal-sm'});
  }


  confirmDeletion(serviceId, id): void {
    this.deleteFileFormat(serviceId, id);
    this.modalRef.hide();
  }
 

  confirmDuplication(id, name): void {
    var formatToDuplicate = this.service.fileFormats.find(fileFormat => fileFormat['id'] === id);
    formatToDuplicate['id'] = null;
    formatToDuplicate['name'] = name;
    formatToDuplicate['serviceId'] = this.service.id
    this.serviceService.addFileFormat(formatToDuplicate).subscribe(service => {
      this.serviceService.updateService(service);
      this.modalRef.hide();
    }, error => {
      this.errorMessage = 'ERRORS.' + error.code;
      this.openModalMessage(this.informationTemplate);
    });
  }
  fetchFromTas(fileFormat){
    let fileformatId = fileFormat.id
    let declarationId = fileFormat.declarationId
    let stageKey = fileFormat.stageKey
    let blockKey = fileFormat.blockKey
    this.tasService.getTasTableData(declarationId, stageKey, blockKey, fileformatId, fileFormat.name, this.service.id, this.service.name).subscribe(data => {
      
    })
  }
  // fetchingFromApi = false
  fetchFromApi(fileFormat){
    let fileformatId = fileFormat.id
    fileFormat['fetchingFromApi'] = true
    setTimeout(() => {
      this.externalApiService.fetchData$(fileformatId).pipe(
          finalize(() => {
            fileFormat['fetchingFromApi'] = false
          })
      ).subscribe({
        next: (data) => {
          this.alertService.success('Fetched data from API')
        },
        error: (err) => {
          this.alertService.error('Error fetching data from API')
          console.error('Error occurred:', err);
        }
      })
    }, 0)


  }


  deleteFileFormat(serviceId, id) {
    var fileFormat = {serviceId: serviceId, id: id}
    this.serviceService.deleteFileFormat(fileFormat)
      .subscribe(service => {
        this.serviceService.updateService(service);
      });
  }

  decline(): void {
    this.modalRef.hide();
  }

  closeModalMessage(): void {
    this.modalRefErrorMessage.hide();
  }

  showFileFormat(value: Object) {
      this.selectedFileFormat = value;
      this.sharedService.changeFileFormatEmit(this.selectedFileFormat)
      this.detectActiveId()
  }

  detectActiveId(){
    this.activeId = !this.selectedFileFormat || !this.selectedFileFormat['fusionImport'] ? 1 : 2
    if (this.selectedFileFormat && this.selectedFileFormat['fusionImport'])
      this.activeId = 2
    if (this.selectedFileFormat && this.selectedFileFormat['externalApiGateway']?.api)
      this.activeId = 3
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  clearSelectedFile(){
    this.selectedFile.nativeElement.value = '';
  }

  /** The fixed enum the portal's revenue-type facet understands. */
  portalCategories = [
    { key: 'direct', tag: 'PORTAL.CATEGORY_DIRECT' },
    { key: 'indirect', tag: 'PORTAL.CATEGORY_INDIRECT' },
    { key: 'customs', tag: 'PORTAL.CATEGORY_CUSTOMS' },
    { key: 'nontax', tag: 'PORTAL.CATEGORY_NONTAX' },
  ];

  /**
   * A mapping object is "usable" once it has a type at all and that type isn't
   * Skip ('1'/1). Mirrors the server's mapColumns `usable` predicate exactly
   * (fusion-server util/portal-mapping.util.js mapColumns): an untyped column
   * (type undefined/null, e.g. freshly imported before the admin picks a type)
   * is not usable even if showInPayeeDataset is already set.
   *
   * Also excludes derived FLUX (mo.flux === true) and special (mo.special ===
   * true) entries, mirroring the same `usable` filter server-side: they never
   * carry a hide checkbox in the UI (visibleMappingObjects in
   * csv-upload.component.ts already drops them) and the server excludes them
   * from `usable` too, not from a later "hidden" step.
   */
  private isUsableColumn(mo: any): boolean {
    return !!mo && mo.type !== undefined && mo.type !== null && mo.type !== '1' && mo.type !== 1
      && mo.flux !== true && mo.special !== true;
  }

  /** Columns the portal will expose: usable and not explicitly hidden (spec D1). */
  publishedColumnCount(fileFormat: any): number {
    return (fileFormat?.['mappingObjects'] || [])
      .filter(mo => this.isUsableColumn(mo) && !mo.hiddenInPortal).length;
  }

  /** Total columns eligible to be published, for the "N of M" readout. */
  eligibleColumnCount(fileFormat: any): number {
    return (fileFormat?.['mappingObjects'] || [])
      .filter(mo => this.isUsableColumn(mo)).length;
  }

  /**
   * Warn when a format is published with nothing to show. The server already
   * fails closed and returns no rows; the point is that the admin knows before
   * a visitor finds an empty dataset.
   */
  portalWarning(fileFormat: any): string | null {
    if (!fileFormat?.['isForPortal']) return null;
    if (this.publishedColumnCount(fileFormat) === 0) return 'PORTAL.WARN_NO_COLUMNS';
    if (!this.service?.isForPortal) return 'PORTAL.WARN_SERVICE_OFF';
    return null;
  }

  /**
   * Pre-fill the portal code from the format name the first time it is
   * published, and clear it when the format is unpublished.
   *
   * Clearing (rather than preserving) is the deliberate choice: the code
   * input only exists in the DOM while `isForPortal` is true (see the
   * template's `@if`), and the code is `required` while it is shown (I2).
   * If we preserved the value across unpublish instead, an admin who hit a
   * duplicate-code 409 and unticked publish to back out would be left with
   * the same stuck, unsaveable service the finding describes -- the code
   * would still fail the server's uniqueness check, but the now-hidden input
   * would give no way to see or fix it. Clearing means unticking publish
   * always yields a saveable format, with no hidden state left behind.
   */
  onPortalPublishToggle(fileFormat: any): void {
    if (fileFormat['isForPortal']) {
      if (!fileFormat['portalCode']) {
        fileFormat['portalCode'] = portalSlug(fileFormat['name'] || '');
      }
    } else {
      fileFormat['portalCode'] = null;
    }
  }

  /** Whether this format is the single one expanded in the accordion. */
  isFormatExpanded(fileFormat: any): boolean {
    // File format ids are loosely typed (string or number depending on the
    // caller), the same reason csvlist.component.ts compares them with `==`.
    // eslint-disable-next-line eqeqeq
    return this.expandedFormatId != null && fileFormat?.['id'] == this.expandedFormatId;
  }

  /** Expands a collapsed format (collapsing whichever was open); collapses an already-expanded one, leaving none open. */
  toggleFormat(fileFormat: any): void {
    this.expandedFormatId = this.isFormatExpanded(fileFormat) ? null : fileFormat?.['id'];
  }

  /**
   * Keeps the accordion collapsed by default. If an admin had expanded a
   * format and it's reloaded (after add/duplicate/delete), preserve that
   * choice. Otherwise, leave all collapsed.
   */
  private resolveExpandedFormat(): void {
    const formats = this.service?.fileFormats || [];
    if (!formats.length) {
      this.expandedFormatId = null;
      return;
    }

    // eslint-disable-next-line eqeqeq
    const stillExists = this.expandedFormatId != null && formats.some(f => f['id'] == this.expandedFormatId);
    if (stillExists) {
      return;
    }

    this.expandedFormatId = null;
  }

  protected readonly FetchType = FetchType;
}
